"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(require("moment"));
var utils_1 = require("../../../utils");
exports.maxDateValidator = {
    name: 'maxDate',
    validation: function (value, element, config) {
        if (utils_1.isEmpty(value)) {
            return true;
        }
        var limit = utils_1.validLimit(config['limit']);
        var valueAsParsedDate = moment_1.default(value, utils_1.PREFERRED_DATE_FORMAT);
        var limitAsParsedDate = moment_1.default(limit, utils_1.PREFERRED_DATE_FORMAT);
        return valueAsParsedDate.isSameOrBefore(limitAsParsedDate);
    },
};
//# sourceMappingURL=MaxDateValidator.js.map